import type { ServerColDef } from '@cmg/data-grid';

import { createModifiedOnColDef } from '../../../../../components/shared-columns/modified-on/modified-on';
import type { InvestorCoverageRow } from '../InvestorCoverageGrid.model';
import { relationshipStatusColDef } from './relationship-status';
import { relationshipTypeColDef } from './relationship-type';

export const investorCoverageColumns: ServerColDef<InvestorCoverageRow>[] = [
  {
    field: 'firmKey',
    headerName: 'Firm Key',
  },
  {
    field: 'firmName',
    headerName: 'CRM Name',
  },
  {
    field: 'location',
    headerName: 'Location',
  },
  relationshipTypeColDef,
  createModifiedOnColDef<InvestorCoverageRow>('lastUpdated'),
  relationshipStatusColDef,
];
